import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
  TiktokIcon,
  TwitterIcon,
  FacebookIcon,
  LinkedInIcon,
  InstagramIcon,
  PlayStoreIcon,
  AppleStoreIcon,
  PinterestIcon,
} from "../assets/icons";
import logoIcon from "../assets/images/logo-icon.png";
import { EMPTY_STRING, SCREEN_PATH } from "../constants";
import { USER_ROLE } from "../system";
import { FaPinterest } from "react-icons/fa";

const Footer = ({ userRole }) => {
  return (
    <footer className="footer mt-4">
      <div className="container">
        <div className="row">
          <div className="col-xl-3 col-lg-12 col-md-12 company-logo">
            <div className="d-flex align-items-center justify-content-center justify-content-xl-start  w-100">
              <img src={logoIcon} height={46} alt="Bayview Shores" />
              <p className="footer-brand-logo">Bayview Shores</p>
            </div>

            <div className="follow-us px-2 d-flex flex-column align-items-start align-items-lg-center ">
              <h6 className="text-center">Follow Us</h6>
              <div className="social-icons d-flex justify-content-center justify-content-md-start mb-2 mb-md-0">
                <a
                  href="https://www.tiktok.com/@sukibayview"
                  target="_blank"
                  rel="noreferrer"
                  className={EMPTY_STRING}
                >
                  <img src={TiktokIcon} alt="Tiktok" />
                </a>
                <a
                  href="https://www.instagram.com/bayviewshoresofficial"
                  target="_blank"
                  rel="noreferrer"
                  className={EMPTY_STRING}
                >
                  <img src={InstagramIcon} alt="Instagram" />
                </a>
                <a
                  href="https://tr.pinterest.com/bayviewshoresofficial"
                  target="_blank"
                  rel="noreferrer"
                  className={EMPTY_STRING}
                >
                  <img src={PinterestIcon} alt="Pinterest" />
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 quick-links">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li>
                <Link
                  to={
                    userRole === USER_ROLE.USER
                      ? SCREEN_PATH.ABOUT_US
                      : SCREEN_PATH.AGENT_ABOUT_US
                  }
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to={
                    userRole === USER_ROLE.USER
                      ? SCREEN_PATH.CONTACT_US
                      : SCREEN_PATH.AGENT_CONTACT_US
                  }
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to={
                    userRole === USER_ROLE.USER
                      ? SCREEN_PATH.FAQ
                      : SCREEN_PATH.AGENT_FAQ
                  }
                >
                  FAQ’s
                </Link>
              </li>
              <li>
                <Link
                  to={
                    userRole === USER_ROLE.USER
                      ? SCREEN_PATH.PRIVACY_POLICY
                      : SCREEN_PATH.AGENT_PRIVACY_POLICY
                  }
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <a className="not-allowed" href={EMPTY_STRING}>
                  <Link
                    to={
                      userRole === USER_ROLE.USER
                        ? SCREEN_PATH.TERMS_AND_CONDITIONS
                        : SCREEN_PATH.AGENT_TERMS_AND_CONDITIONS
                    }
                  >
                    Terms and Conditions
                  </Link>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 contact-us">
            <h5>Reach Us At</h5>
            <p>
              <a href="mailto:letstalk@bayviewshores.com">
                letstalk@bayviewshores.com
              </a>
            </p>
          </div>
          <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 our-address">
            <h5>Got a Suggestion</h5>
            <p>
              <a href="mailto:suggestions@bayviewshores.com">
                suggestions@bayviewshores.com
              </a>
            </p>
          </div>
          <div className="col-xl-2 col-lg-3 col-md-12 col-sm-6 app-download-link">
            <h5>Get the app</h5>
            <div className="store-buttons-container">
              <a
                href="https://apps.apple.com/us/app/bayview-shores/id6741199790?l=en-GB"
                className="store-button apple-button"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={AppleStoreIcon}
                  alt="Apple Store"
                  className="store-logo"
                />
                <div className="store-text">
                  <span>Download on the</span>
                  <br />
                  <span>Apple Store</span>
                </div>
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.bvs.mobile"
                className="store-button google-button"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={PlayStoreIcon}
                  alt="Google Play"
                  className="store-logo"
                />
                <div className="store-text">
                  <span>Get it on</span>
                  <br />
                  <span>Google Play</span>
                </div>
              </a>
            </div>
          </div>
        </div>
        <hr />
        <div className="copyright">
          <p className="m-1">Copyright &copy; {new Date().getFullYear()}, BayviewShores</p>
        </div>
      </div>
    </footer>
  );
};

const mapStateToProps = (state) => ({
  userRole: state.authReducer.userRole,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
